import type { Analytics } from '../analytics/types';

import type { ForgotPasswordOptions } from './types';
import getWebAuth from './utils/getWebAuth';
import { mapError } from './utils/mapError';

const forgotPassword = async (
  { trackLink }: Analytics,
  { emailAddress, connection }: ForgotPasswordOptions,
): Promise<void> =>
  new Promise((resolve, reject) => {
    const webAuth = getWebAuth();
    webAuth.changePassword(
      {
        email: emailAddress,
        connection,
      },
      (error) => {
        if (error) {
          const reason = mapError(error, trackLink, 'forgotPassword.error');

          reject(reason);
          return;
        }

        resolve();
      },
    );
  });

export default forgotPassword;
